import React, { useState } from "react"
import { FaUserAlt } from "react-icons/fa";
import mobileHeaderStyles from "../../MobileHeader.module.css"
import MobileProfileDrawer from "../MobileProfileDrawer/MobileProfileDrawer"

// import Drawer from "@mui/material/Drawer";
// import Login from "../../../Login/Login";
// import VerifyOtp from "../../../Login/VerifyOtp";
// import {
//   selecttoken,
//   selectloginSlider,
//   setloginSliderstate,
//   selectVerifySlider,
//   setVerifyOtpSliderstate,
//   selectOnCloseDisableLoginSlider
// } from "../../../../src/slice/LoginPageSlice";
import { useSelector, useDispatch } from "react-redux";


const MobileProfile = () => {
  const dispatch = useDispatch();

  const [openProfileDrawer, setOpenProfileDrawer] = useState(false);

  // const loginSlider = useSelector(selectloginSlider);
  // const verifySlider = useSelector(selectVerifySlider);
  // const onCloseLoginSliderDeactive = useSelector(selectOnCloseDisableLoginSlider);

  const handleMobileProfileClick = () => {
    // console.log("clicked on profile");
    try {
      const userDetails = JSON.parse(localStorage.getItem("user"));
      const token = userDetails && userDetails?.token;
      if (token) {
        setOpenProfileDrawer(true);
      } else {
        window.location.href = process.env.RAZZLE_APP_BASE_URL;
        // dispatch(setloginSliderstate(true));
      }
    }
    catch {
      // console.log("Token Not Found")
    }
  };

  return (
    <>
      <div className={mobileHeaderStyles.iconContainer} onClick={handleMobileProfileClick}>
        <FaUserAlt className={mobileHeaderStyles.profileIcon} />
      </div>
      {openProfileDrawer && <MobileProfileDrawer setOpenProfileDrawer={setOpenProfileDrawer} />}
      {/* <Drawer
        anchor="right"
        open={loginSlider}
        onClose={() => {
          if (onCloseLoginSliderDeactive) {
            console.log("Cannot close slider")
          } else {
            dispatch(setloginSliderstate(false));
          }
        }}
      >
        <Login />
      </Drawer>
      <Drawer
        anchor="right"
        open={verifySlider}
        onClose={() => dispatch(setVerifyOtpSliderstate(false))}
      >
        <VerifyOtp />
      </Drawer> */}
    </>
  )
}

export default MobileProfile;